<template>
  <div
    data-tag
    :class="componentClass"
    :style="{
      color: options.view.theme === 'light' && options.css.modules.vacancies.backgroundColor
    }">
    <span><slot></slot></span>
    <span :class="$style.close">&times;</span>
  </div>
</template>

<script>
import vueTypes from 'vue-types'
import cx from 'classnames'

export default {
  name: 'Tag',

  props: {
    variant: vueTypes.oneOf([
      'primary',
      'secondary'
    ]).def('primary'),
    options: vueTypes.object
  },

  computed: {
    componentClass () {
      const light = {
        [this.$style.primary]: this.variant === 'primary',
        [this.$style.secondary]: this.variant === 'secondary'
      }
      const dark = {
        [this.$style.primaryDark]: this.variant === 'primary',
        [this.$style.secondaryDark]: this.variant === 'secondary'
      }

      return cx(this.options.view.theme === 'dark' ? dark : light)
    }
  }
}
</script>

<style module>
  .primary {
    position: relative;
    display: inline-block;
    background: rgba(255, 255, 255, 0.7);
    color: white;
    padding: 1px 25px 3px 8px;
    font-weight: 400;
    font-size: 16px;
    border: 1px solid transparent;
    border-radius: 4px;
    cursor: pointer;
    transition: all 300ms ease-out;
    margin-right: 8px;
    margin-bottom: 8px;

    &:hover {
      background: rgba(255, 255, 255, 0.3);
    }
  }

  .secondary {
    composes: primary;
    color: $skyDark;
    background: transparent;
    border: 1px solid $skyLighter;

    &:hover {
      background: $skyLight;
      color: rgba(0, 0, 0, 0.7);
    }
  }

  .primaryDark {
    composes: primary;
    background: rgba(0, 0, 0, 0.3);
    color: $white; /* apply background color */

    &:hover {
      background: rgba(0, 0, 0, 0.7);
    }
  }

  .close {
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
    font-size: 19px;
    color: currentColor;
  }
</style>
